<template>
  <el-tooltip
    :content="tooltip"
    :disabled="!tooltip"
    placement="top"
  >
    <a-button
      :status="status"
      :size="size"
      :disabled="disabled"
      :type="type"
      @click="$emit('click', $event)"
    >
    <el-icon  v-if="iconName" ><component :is="iconName"/></el-icon>
    <icon-edit v-else />
    </a-button>
  </el-tooltip>
</template>

<script>
export default {
  name: 'EditButton',
  props: {
    // 按钮状态
    status: {
      type: String,
      default: '' // primary | danger | warning | success 等
    },
    type:{
      type: String,
      default: 'secondary'
    },
    // 按钮大小
    size: {
      type: String,
      default: 'mini' // mini | small | large
    },
    // 禁用状态
    disabled: {
      type: Boolean,
      default: false
    },
    // 自定义图标名称
    iconName: {
      type: String,
      default: ''
    },
    // 提示文本（可选）
    tooltip: {
      type: String,
      default: ''
    }
  }
}
</script>